import React from 'react';
import { Nullable } from 'global';
import { formatCurrency } from 'utils';
import { Typography } from '@mui/material';

import { QuoteCalcViewModel } from '../../../../api/types';

export const EquipmentChargeGrandTotalCell = ({ priceCalc }: { priceCalc: Nullable<QuoteCalcViewModel> }) => {
  return <Typography>{formatCurrency(priceCalc?.totals?.grandTotal ?? null, true)}</Typography>;
};
